export default __webpack_public_path__ + "static/media/attach_file.8c3c8dec.svg";